import { RDEqipEligibilityFarmInfo } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { FarmInfoTaskEditor } from '../../FarmInfoEditor'

// This is a field detail
export const RDEqipEligibilityFarmInfoDetailFeature: ResourceDetailFeature<RDEqipEligibilityFarmInfo> = {
  traitId: 'eqipEligibilityFarmInfo',
  TaskEditor: FarmInfoTaskEditor,
}
